import { oc } from "@orpc/contract";
import { z } from "zod";

/**
 * Customer match test request schema
 */
export const TestCustomerMatchRequestSchema = z.object({
  inboundEmailId: z.uuid("Invalid inbound email ID format"),
});

/**
 * Customer match test response schema
 */
export const TestCustomerMatchResponseSchema = z.object({
  success: z.boolean(),
  match: z
    .object({
      customerId: z.uuid(),
      customerName: z.string(),
      confidence: z.enum(["high", "medium", "low"]),
      reasoning: z.string(),
      matchScore: z.number().min(0).max(1).optional(),
    })
    .optional(),
  error: z.string().optional(),
  metrics: z
    .object({
      totalTime: z.number(),
      pineconeQueryTime: z.number(),
      customerEnrichmentTime: z.number(),
      aiProcessingTime: z.number(),
      pineconeResultsCount: z.number(),
      highConfidenceMatch: z.boolean(),
      aiUsed: z.boolean(),
    })
    .optional(),
});

/**
 * Test customer matching contract
 */
export const testCustomerMatchContract = oc
  .input(TestCustomerMatchRequestSchema)
  .output(TestCustomerMatchResponseSchema)
  .route({
    method: "POST",
  });

export type TestCustomerMatchRequest = z.infer<
  typeof TestCustomerMatchRequestSchema
>;
export type TestCustomerMatchResponse = z.infer<
  typeof TestCustomerMatchResponseSchema
>;
